"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var preflight = process.env.NODE_ENV === "production" ? {
  name: "1b8dtnc",
  styles: "font-family:inherit;font-size:100%;line-height:1.15;margin:0;text-transform:none"
} : {
  name: "t5f4nx-preflight",
  styles: "font-family:inherit;font-size:100%;line-height:1.15;margin:0;text-transform:none;label:preflight;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var styles = {
  preflight: preflight
};
exports.styles = styles;
//# sourceMappingURL=select.styles.js.map